import React, { FC } from 'react'
import { FaQuestionCircle } from 'react-icons/fa'

const ToggleHelpDrawer: FC = () => (
  <button
    id='kt_help_toggle'
    className='engage-help-toggle btn btn-flex align-items-center justify-content-center bg-primary text-white shadow-sm'
    title='Help & Support Center'
    data-bs-toggle='tooltip'
    data-bs-placement='left'
    data-bs-dismiss='click'
    data-bs-trigger='hover'
  >
    <FaQuestionCircle className='fs-6 me-1 text-white' />
    <span>Help</span>
  </button>
)

export { ToggleHelpDrawer }
